<template>

  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item
        v-for="(item, index) in levelList"
        :key="item.path"
        v-if="item.meta.title"
      >
        <span
          v-if="item.redirect === 'noredirect' || index == levelList.length - 1"
          class="no-redirect"
          >{{ item.meta.title }}</span
        >
        <span v-else :to="item.redirect || item.path">{{
          item.meta.title
        }}</span>
        <!-- <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link> -->
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb();
  },
  data() {
    return {
      levelList: null,
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter((item) => item.name);
      let crumb = [];

      if (matched.length>1 && matched[1].name ==="addModel") {
          let resultStr = this.substr(this.$route.fullPath);
          //console.log(resultStr,'resultStr--000999')
          let versionNum = ''
          if(resultStr.versionNumber){
            versionNum =  resultStr.versionNumber
          }
          let modelName =''
          if(resultStr.modelName){
            // modelName = '   '+resultStr.modelName
            modelName = '   '+decodeURI(resultStr.modelName)
          }
          let obj = {
            path: "5yu1",
            meta: { title: decodeURI(resultStr.type) +  versionNum +modelName },
          };
          crumb.push(obj);
          matched.splice(1, 2);
        
      } else if (matched.length > 1 && matched[1].name == "allocResource") {
        let resultStr1 = this.$route.fullPath.split("?");
        if (resultStr1.length > 1) {
          let obj = {
            path: "5yu",
            meta: { title: "编辑" },
          };
          crumb.push(obj);
          matched.splice(1, 2);
        }
      } else if (matched[0].name == "ums-doc") {
        if (!!this.$route.fullPath.split("?")[1]) {
          let resultStr = this.substr(this.$route.fullPath);
          if (resultStr.id && resultStr.view === "false") {
            let obj = {
              path: "23yu",
              meta: { title: "编辑" },
            };
            crumb.push(obj);
          } else if (resultStr.id && resultStr.view === "true") {
            let obj1 = {
              path: "23撒旦yu",
              meta: { title: "查看" },
            };
            crumb.push(obj1);
          } else {
            let obj2 = {
              path: "23撒旦是的是的yu",
              meta: { title: "新增" },
            };
            crumb.push(obj2);
          }
          // crumb.push({meta:{title:'编辑'}})
          matched.splice(1, 2);
        }
      }

      // this.levelList = matched;
      this.levelList = [...matched, ...crumb];
      // //console.log( this.levelList)
    },
    substr(str) {
      var str1 = str.split("?")[1];
      var str2 = str1.split("&");
      var obj = {};
      for (var i = 0; i < str2.length; i++) {
        var a = str2[i].split("=");
        obj[a[0]] = a[1];
      }
      return obj;
    },
  },
};
</script>
<style >
.app-breadcrumb .el-breadcrumb__inner {
  color: #fff !important;
}
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;
  .no-redirect {
    color: #fff;
    cursor: text;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue